'use client';

import { c as _c } from "react/compiler-runtime";
import SvgChevrondown from '@common/icon/SvgChevrondown';
import SvgChevronup from '@common/icon/SvgChevronup';
import { cn } from '@core/utils';
import { useCallback, useEffect, useRef, useState } from 'react';
import { DeliveryNoticeImage } from '@/app/_components/DeliveryNoticeImage';
import { TABS } from '../constants';
import { TabDelivery } from './TabDelivery';
import { TabInquiry } from './TabInquiry';
import { TabProductInfo } from './TabProductInfo';
import { TabReview } from './TabReview';
const COLLAPSED_HEIGHT = 500;
interface MarketDetailContentProps {
  productInfo: string;
  productInfoSections: Array<{
    sectionName: string;
    items: Array<{
      key: string;
      value: string;
    }>;
  }>;
  vendorContactNumber: string;
  deliveryFee: number;
  deliveryCompanyName: string;
  productId: string;
  productImageUrl?: string;
  vendorRegion?: string;
  vendorName?: string;
  productName?: string;
}
export const MarketDetailContent = t0 => {
  const $ = _c(40);
  const {
    productInfo,
    productInfoSections,
    vendorContactNumber,
    deliveryFee,
    deliveryCompanyName,
    productId,
    productImageUrl,
    vendorRegion,
    vendorName,
    productName
  } = t0;
  const [isExpanded, setIsExpanded] = useState(false);
  const sectionRef = useRef(null);
  const contentRef = useRef(null);
  const isAnimating = useRef(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const element = contentRef.current;
      if (!element) {
        return;
      }
      element.style.maxHeight = `${COLLAPSED_HEIGHT}px`;
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      const element_0 = contentRef.current;
      if (!element_0 || isAnimating.current) {
        return;
      }
      isAnimating.current = true;
      element_0.style.transition = "max-height 300ms ease-in-out";
      element_0.style.maxHeight = `${element_0.scrollHeight}px`;
      const onEnd = () => {
        element_0.style.maxHeight = "none";
        element_0.style.transition = "";
        isAnimating.current = false;
        element_0.removeEventListener("transitionend", onEnd);
      };
      element_0.addEventListener("transitionend", onEnd);
      setIsExpanded(true);
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleExpand = t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const element_1 = contentRef.current;
      if (!element_1 || isAnimating.current) {
        return;
      }
      isAnimating.current = true;
      const sectionTop = sectionRef.current?.getBoundingClientRect().top ?? 0;
      const scrollY = window.scrollY;
      element_1.style.transition = "none";
      element_1.style.maxHeight = `${element_1.scrollHeight}px`;
      requestAnimationFrame(() => {
        element_1.style.transition = "max-height 300ms ease-in-out";
        element_1.style.maxHeight = `${COLLAPSED_HEIGHT}px`;
      });
      const onEnd_0 = () => {
        element_1.style.transition = "";
        isAnimating.current = false;
        element_1.removeEventListener("transitionend", onEnd_0);
        const newSectionTop = sectionRef.current?.getBoundingClientRect().top ?? 0;
        const diff = newSectionTop - sectionTop;
        window.scrollTo({
          top: scrollY + diff
        });
      };
      element_1.addEventListener("transitionend", onEnd_0);
      setIsExpanded(false);
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const handleCollapse = t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DeliveryNoticeImage />;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== productInfo) {
    t6 = <div ref={contentRef} className="prose max-w-none overflow-hidden" dangerouslySetInnerHTML={{
      __html: productInfo
    }} />;
    $[5] = productInfo;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = isExpanded ? "opacity-0" : "opacity-100";
  let t8;
  if ($[7] !== t7) {
    t8 = cn("pointer-events-none absolute inset-x-0 bottom-0 h-100 bg-gradient-to-t from-Gray-white to-transparent transition-opacity duration-300", t7);
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t8) {
    t9 = <div className={t8} />;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t6 || $[12] !== t9) {
    t10 = <div className="relative">{t6}{t9}</div>;
    $[11] = t6;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== isExpanded) {
    t11 = !isExpanded ? <button type="button" onClick={handleExpand} className="mt-16 flex w-full items-center justify-center gap-4 border border-Gray-300 py-12 font-600 text-Gray-700 typo-body3">상품정보 더보기<SvgChevrondown className="size-16 text-Gray-600" /></button> : <button type="button" onClick={handleCollapse} className="mt-16 flex w-full items-center justify-center gap-4 border border-Gray-300 py-12 font-600 text-Gray-700 typo-body3">상품정보 접기<SvgChevronup className="size-16 text-Gray-600" /></button>;
    $[14] = isExpanded;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t10 || $[17] !== t11) {
    t12 = <section id={TABS.BASIC} ref={sectionRef} className="mobile-tablet:px-20">{t5}{t10}{t11}</section>;
    $[16] = t10;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  const t13 = vendorName ?? "";
  let t14;
  if ($[19] !== productInfoSections || $[20] !== t13 || $[21] !== vendorContactNumber) {
    t14 = <TabProductInfo productInfoSections={productInfoSections} vendorName={t13} vendorContactNumber={vendorContactNumber} />;
    $[19] = productInfoSections;
    $[20] = t13;
    $[21] = vendorContactNumber;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== deliveryCompanyName || $[24] !== deliveryFee) {
    t15 = <TabDelivery deliveryFee={deliveryFee} deliveryCompanyName={deliveryCompanyName} />;
    $[23] = deliveryCompanyName;
    $[24] = deliveryFee;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== productId) {
    t16 = <TabReview productId={productId} />;
    $[26] = productId;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== productId || $[29] !== productImageUrl || $[30] !== productName || $[31] !== vendorName || $[32] !== vendorRegion) {
    t17 = <TabInquiry productId={productId} productImageUrl={productImageUrl} vendorRegion={vendorRegion} vendorName={vendorName} productName={productName} />;
    $[28] = productId;
    $[29] = productImageUrl;
    $[30] = productName;
    $[31] = vendorName;
    $[32] = vendorRegion;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t12 || $[35] !== t14 || $[36] !== t15 || $[37] !== t16 || $[38] !== t17) {
    t18 = <div className="flex flex-col gap-80 mobile-tablet:gap-40">{t12}{t14}{t15}{t16}{t17}</div>;
    $[34] = t12;
    $[35] = t14;
    $[36] = t15;
    $[37] = t16;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  return t18;
};